import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams } from 'react-router-dom';
import { formatDate  } from '../../utils/helper.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Details = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [event, setEvent] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [tab, setTab] = useState("info");
    const { id } = useParams();

    
    useEffect(() => {
        getEventDetails();
    }, []);

    const getEventDetails = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "events/"+id, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                setEvent(data.data);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

 

    const delData = async (mid) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'no',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `del-member/${id}`, // Replace with your API endpoint
                data:{user_id:mid}
            });
            const data = response.data;
            if (data.status) {
                getEventDetails();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 


    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            Event: {event?.title}</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Events</li>
                        </ul>
                    </div>
                    <div className="d-flex align-events-center gap-2 gap-lg-3">
                        {/* Add New events Button */}
                        <Link to={`/events/create`}  className='btn btn-base btn-sm'>Add New Event</Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                       <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            <button
                                className={`nav-link fs-lg-5 ${tab === "info" ? "active" : ""}`}
                                onClick={() => setTab("info")}
                                id="nav-profile-tab"
                                type="button"
                            >
                                <i className="bi bi-person-video"></i> Event Info 
                            </button>
                            <button
                                className={`nav-link fs-lg-5 ${tab === "members" ? "active" : ""}`}
                                onClick={() => setTab("members")}
                                id="nav-contact-tab"
                                type="button"
                            >
                                <i className="bi bi-people-fill"></i> Members
                            </button>
                            </div>
                        </nav>
                        <div className="card-body pt-0">
                            <div id="kt_events_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    {tab === "info" && (
                                        <table className="table align-middle table-striped fs-6 gy-5 ">
                                        
                                            <tbody className="text-gray-600 fs-6">
                                                <tr>
                                                    <th className='fw-semibold'>Title</th>
                                                    <td>{event?.title}</td>
                                                </tr>
                                                <tr>
                                                    <th className='fw-semibold'>Description</th>
                                                    <td>{event?.description}</td>
                                                </tr>
                                                <tr>
                                                    <th className='fw-semibold'>Tags</th>
                                                    <td>
                                                        {event?.tags && event.tags.map((tag, index) => (
                                                            <span className='badge bg-base mx-1'>{tag}</span>
                                                        ))}
                                                        
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th className='fw-semibold'>Date & Time</th>
                                                    <td>{formatDate(event?.date,'DD MMM YYYY')}  {event?.start_time} - {event?.end_time}</td>
                                                </tr>
                                                <tr>
                                                    <th className='fw-semibold'>Location</th>
                                                    <td>{event?.address?.location}</td>
                                                </tr>

                                                <tr>
                                                    <th className='fw-semibold'>Images</th>
                                                    <td>
                                                        {event?.images && event.images.map((evnt, index) => (
                                                            <img src={evnt.image} alt="event" className="w-70px rounded m-1" />
                                                        ))}
                                                    </td>
                                                </tr>
                                            
                                                
                                            </tbody>
                                        </table> 
                                    )}
                                    {tab === "members" && (
                                        <table className="table align-middle table-striped fs-6 gy-5 ">
                                            <thead>
                                                <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                    <th>{("Picture")}</th>
                                                    <th>{("Name")}</th>
                                                    <th>{("Email")}</th>
                                                    <th>{("Phone")}</th>
                                                    {/* <th>{("Joined At")}</th> */}
                                                    <th>{("Actions")}</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fs-6">
                                                {event?.members && event.members.map((member, index) => (
                                                    <tr>
                                                        <td>
                                                            <img src={member.picture} alt="user" className="w-50px rounded-circle" />
                                                        </td>
                                                        <td>
                                                            {member.name}
                                                        </td>
                                                        <td>
                                                            {member.email}
                                                        </td>
                                                        <td>
                                                            {member.phone}
                                                        </td>
                                                        {/* <td>
                                                            {member.created_at}
                                                        </td> */}
                                                        <td>
                                                            <button  onClick={() => delData(member.id)} className="btn btn-sm h-30px btn-light-primary">
                                                                {/* <i className="bi bi-trash-fill fs-6"></i> */}
                                                                Remove
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                               

                                                
                                                
                                            </tbody>
                                        </table> 
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Details;
